export default "__VITE_ASSET__CmxvnEMq__"